export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-16 bg-background-50 rounded-lg border border-background-200/60 overflow-hidden p-6 md:p-10">
          <div className="flex-1 text-center lg:text-left">
            <span className="inline-block px-3 py-1 bg-accent-100 text-accent-700 text-xs font-medium rounded-full mb-4">
              随时随地 · 畅快追漫
            </span>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">移动端流畅阅读体验</h2>
            <p className="text-sm md:text-base text-foreground-500 leading-relaxed mb-6 max-w-md mx-auto lg:mx-0">
              51动漫网全面适配移动端浏览器，无需下载应用即可在手机上享受流畅的下拉式阅读体验。
              自适应排版让每一页漫画都清晰呈现，随时随地追更不中断。
            </p>
            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4">
              <div className="flex items-center gap-2 text-sm text-foreground-600">
                <i className="ri-smartphone-line text-lg text-primary-500"></i>
                <span>手机浏览器直达</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-foreground-600">
                <i className="ri-tablet-line text-lg text-primary-500"></i>
                <span>平板完美适配</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-foreground-600">
                <i className="ri-wifi-line text-lg text-primary-500"></i>
                <span>无需下载安装</span>
              </div>
            </div>
          </div>

          <div className="flex-shrink-0">
            <div className="w-64 h-[420px] rounded-lg overflow-hidden bg-background-100 border border-background-200/60">
              <img
                src="https://readdy.ai/api/search-image?query=Smartphone%20mockup%20displaying%20anime%20manga%20reading%20app%20interface%20with%20colorful%20manga%20page%20on%20screen%2C%20clean%20modern%20UI%20design%2C%20warm%20coral%20accent%20colors%2C%20Japanese%20manga%20reader%20layout%2C%20minimal%20phone%20case%2C%20floating%20on%20soft%20cream%20background%2C%20product%20photography%20style&width=600&height=900&seq=51anime-app&orientation=portrait"
                alt="51动漫网移动端阅读体验"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}